import BaseFeaturedSectionRouteStore from "./BaseFeaturedSectionRouteStore";

class NakiMobileFeaturedSectionRouteStore extends BaseFeaturedSectionRouteStore {
    constructor(rootStore) {
        super(rootStore);
    }
}

export default NakiMobileFeaturedSectionRouteStore;
